<template>
    <div class="d-flex justify-center mt-12" style="height: 100%">
        <div class="mt-12 pt-12 sansation_title">Oops, this page does not exist!</div>
    </div>
</template>

<script>

  export default {
    name: '404',
    data() {
      return {

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/404.vue